export default "__VITE_ASSET__BYTfwxCl__"